import { BarController, BarElement, Chart, ChartArea, LineController, LineElement, PointElement } from 'chart.js';

function GetCenterIndex(chart: Chart) {
  try {
    const rec = chart.canvas.getBoundingClientRect();
    const elts = chart.getElementsAtEventForMode({
      clientX: rec.left + rec.width / 2,
      clientY: rec.top + rec.height / 2,
    } as any, 'index', {intersect: false}, false);

    return elts[0]?.index;
  } catch (error) {
    return;
  }
}

export class CustomBarController extends BarController {
  static id = 'customBar';

  static defaults = {
    dataElementType: 'customBar',
  };

  updateElements(elements, start: number, count: number, mode): void {
    const centerIndex = GetCenterIndex(this.chart);

    if (count !== elements.length) {
      return;
    }

    if (elements[0]?.options && typeof centerIndex !== 'undefined') {
      start = centerIndex - 100 < 0 ? 0 : centerIndex - 100;
      count = start + 200 > elements.length ? elements.length - start : 200;
      super.updateElements(elements, start, count, mode);
    } else {
      super.updateElements(elements, 0, elements.length, mode);
    }
  }
}

export class CustomBarElement extends BarElement {
  static id = 'customBar';

  draw(ctx: CanvasRenderingContext2D, area?: ChartArea): void {
    if (this.x > ctx.canvas.width || this.x < 0) {
      return;
    }
    super.draw(ctx, area);
  }
}


export class CustomLineController extends LineController {
  static id = 'customLine';

  static defaults = {
    datasetElementType: 'customLine',
    dataElementType: 'customPoint',
  };

  updateElements(points, start, count, mode) {
    const centerIndex = GetCenterIndex(this.chart);

    if (points[0]?.options && typeof centerIndex !== 'undefined') {
      start = centerIndex - 50 < 0 ? 0 : centerIndex - 50;
      count = start + 100 > points.length ? points.length - start : 100;
      super.updateElements(points, start, count, mode);
    } else {
      super.updateElements(points, start, count, mode);
    }
  }

}

export class CustomPointElement extends PointElement {
  static id = 'customPoint';

  draw(ctx: CanvasRenderingContext2D, area?: ChartArea): void {
    if (this.active) {
      super.draw(ctx, area);
    }
  }
}

export class CustomLineElement extends LineElement {
  static id = 'customLine';

  draw(ctx: CanvasRenderingContext2D, area?: ChartArea): void {
    const centerIndex = GetCenterIndex((this as any)._chart);
    if (this.options && typeof centerIndex !== 'undefined') {
      const points = this.points;
      const start = centerIndex - 50 < 0 ? 0 : centerIndex - 50;
      const count = start + 100 > points.length ? points.length - start : 100;
      (super.draw as any)(ctx, area, start, count);
    } else {
      super.draw(ctx, area);
    }
  }
}